<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞家庭教育</span>
      </div>
      <div class="content">
        <div>
          <p>针对中小学生面对的升学压力，公司引进国内外先进教育理念和教学方法，开发高效的语数外等各科助学软件，
            助力莘莘学子，升学路上先人一步。我们的产品着眼于让学生们的时间利用更加高效，学习在课内升华在课外，
            知识的迁移和转化更加自然，能力提升水到渠成。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myheadert from '../header/header_0.vue'
export default {
  name: 'education',
  components: {
    myheadert
  },
  data () {
    return {

    }
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 1500px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 900px;
    margin-top: 25px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: 1%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 内容 */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 11pt;
    font-family: '宋体'
  }

}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 750px;
    margin-top: 20px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -3%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /*  */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 600px;
    /* margin-left: 20px; */
    margin-top: 10px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -6%;
    margin-left: 14.5%;
    font-size: 16px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 3%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /*  */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }

}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 400px;
    /* margin-left: 30px; */
    /* margin-top: 10px; */
  }
  /* 位置 */
  .location{
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -11%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 3%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }

  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }

}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 500px;
    margin-left: 50px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -12%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 3%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /*  */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }

}
@media screen and (max-width:701px){
  .main{
    width: 100%;
  }
  /* 顶部 */
  .head{
    width: 100%;
    height: auto;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .title{
    width: 50%;
    margin-left: 30%;
    margin-top: 10px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: 10px;
    margin-left: 10%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 6%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 1.2%;
    top: -5px;
    cursor: pointer;
  }

  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
</style>



// WEBPACK FOOTER //
// src/components/education/education.vue